import axios from "axios";
import { useState, useEffect } from "react";

const useFetchBiens = (ID_PERSO) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let qualites = await axios.get(
          `https://taboni-soft-api.labo-linkibe.fr/api/qualites?filters[ID_PERSO][$eq]=${ID_PERSO}`
        );
        qualites = qualites.data?.data;
        let immeubles = [];
        if (qualites.length) {
          for (let qualite of qualites) {
            let ImmeubleCode = qualite.attributes.IIII;
            let immeuble = await axios.get(
              `https://taboni-soft-api.labo-linkibe.fr/api/immeubles?filters[IIII][$eq]=${ImmeubleCode}`
            );
            immeuble = immeuble.data.data[0];
            immeubles.push({
              id: immeuble.id,
              NOM_IMM: immeuble.attributes.NOM_IMM,
              IIII: immeuble.attributes.IIII,
            });
          }
        }
        if (immeubles) {
          setData((prevState) => {
            return [...prevState, ...immeubles];
          });
        }
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, [ID_PERSO]);

  return { data, loading, error };
};

export default useFetchBiens;
